import clsx from "clsx";
import React from "react";

export const BalanceElement= ({
  icon,
  valueFirst,
  valueSecond,
  symbol,
}) => {

  return (
    <li
      className={clsx(
        'flex items-center justify-between px-3 py-[9px] border-b-[1px] w-full',
      )}
    >
      <div className="flex items-center gap-1">
        <div className="relative">
          <img
            src={icon}
            alt="currency icon"
            className={clsx(
              'min-w-7 min-h-7 max-w-7 max-h-7',
            )}
          />
        </div>

        <div className="flex flex-col ">
          <span
            className={clsx(
              'text-black uppercase font-Inter font-medium test-base leading-[19px] dark:text-white',

            )}
          >
            {symbol}
          </span>
        </div>
      </div>

      {valueSecond && (
        <div className="flex flex-col items-end">
          <span className="text-blue font-Inter font-medium test-base leading-[24px]">
            {valueSecond}
          </span>

          <span className="text-sm font-Inter font-normal leading-[17px] text-white-40 dark:text-white-50">
              {valueFirst ? <>{valueFirst}</> : ''}
            </span>
        </div>
      )}
    </li>
  );
};
